import ActionTypes from "../../../../constants/ActionTypes";
import { IProductPrepared } from "../../../../entities/product/types";
import { IFetchProductsAction, IProductsState, ISetProductsAction, IEnrichProductsAction } from "./types";

export function requestFetchAllProducts(params: object): IFetchProductsAction {
  return {
    type: ActionTypes.PRODUCTS.FETCH,
    params,
  };
}

export function setProductsAction(products: IProductsState[]): ISetProductsAction {
  return {
    type: ActionTypes.PRODUCTS.SET,
    payload: products,
  };
}

export function setFilteredProductsAction(products: IProductsState[]): ISetProductsAction {
  return {
    type: ActionTypes.PRODUCTS.SET_FILTERED,
    payload: products,
  };
}

export function setSearchedProductsAction(products: any[]): ISetProductsAction {
  return {
    type: ActionTypes.PRODUCTS.SET_SEARCHED,
    payload: products,
  };
}


export function enrichProductsAction(
  products: IProductsState[],
  pageData: any,
  oldProducts?: IProductPrepared[]
): IEnrichProductsAction {
  return {
    type: ActionTypes.PRODUCTS.ENRICH,
    payload: {
      products,
      pageData,
      oldProducts,
    }
  };
}

